export enum DateRangeFilterOption {
  TODAY = 'today',
  LATEST = 'latest',
  LAST_7_DAYS = 'last-7-days',
  LAST_30_DAYS = 'last-30-days',
  LAST_60_DAYS = 'last-60-days',
  LAST_3_MONTHS = 'last-3-months',
  LAST_6_MONTHS = 'last-6-months',
  THIS_YEAR = 'this-year',
  LAST_YEAR = 'last-year',
  THIS_WEEK = 'this-week',
  NEXT_WEEK = 'next-week',
  LAST_WEEK = 'last-week',
  THIS_MONTH = 'this-month',
  NEXT_MONTH = 'next-month',
  LAST_MONTH = 'last-month'
}
